import React from "react";
import {Box} from "@mui/material";
import importedStyles from "../../Proactive/Utilities/campaignStyles";
import CreateUserInviteForm from "./CreateUserInviteForm";
import BackToInvites from "./BackToInvites";

export default function CreateUserInvite() {

    return(
        <>
            <Box sx={importedStyles.root}>
                <Box sx={styles.container}>
                    <Box sx={styles.backButtonContainer}>
                        <BackToInvites />
                    </Box>
                    <Box sx={importedStyles.containerBody}>
                        <Box sx={importedStyles.header}>
                            Invite user
                        </Box>
                        <CreateUserInviteForm />
                    </Box>
                </Box>
            </Box>
        </>
    )
}

const styles = {
    container: {
        px: { xs: 2, sm: 6 },
        maxWidth: '700px',
        position: 'relative',
    },
    backButtonContainer: {
        height: '30px',
        mt: '-30px'
    }
}